var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-progress-circles"},_vm._l((_vm.circles),function(step,stepIndex){return _c('div',{key:stepIndex,staticClass:"app-progress-circles__step",class:{'app-progress-circles__step--filled': stepIndex === _vm.index}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }